import { STALE_TIME_RESOURCES } from "@impero-com/common/utils/query_client";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";

import { getControlProgramsTags } from "api/generated/control-program/control-program";
import {
    ControlProgramTagCategoryView,
    ControlProgramTagView,
} from "api/generated/model";

export interface ControlProgramTagsQuerySelect {
    tags: ControlProgramTagView[];
    tagCategories: ControlProgramTagCategoryView[];
}

export const CONTROL_PROGRAM_TAGS_QUERY_KEY = "controlProgramTags";

export function useControlProgramTagsQuery(
    placeholderData?: ControlProgramTagsQuerySelect,
    enabled = true
) {
    return useQuery({
        queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
        queryFn: controlProgramTagsQueryFn,
        select: (data) => data,
        placeholderData,
        enabled,
        retry: true,
        staleTime: STALE_TIME_RESOURCES,
        refetchOnWindowFocus: true,
    });
}

export function useControlProgramTagsSuspenseQuery() {
    return useSuspenseQuery({
        queryKey: [CONTROL_PROGRAM_TAGS_QUERY_KEY],
        queryFn: controlProgramTagsQueryFn,
        select: (data) => data,
        retry: true,
        staleTime: STALE_TIME_RESOURCES,
    });
}

async function controlProgramTagsQueryFn(): Promise<ControlProgramTagsQuerySelect> {
    const response = await getControlProgramsTags();
    return {
        tags: response.data.content.map((content) => content.resource),
        tagCategories: response.data.linkedResources,
    };
}
